export { default as ProductCardGallery } from './product-card-gallery'
export { default as ProductCardExtended } from './product-card-extended'
export { default as ProductCardEol } from './product-card-eol'
export { default as ProductCardCompact } from './product-card-compact'
export { default as ProductCardStripped } from './product-card-stripped'
export { default as ProductCardCampaign } from './product-card-campaign'
export { ProductCardGallerySwitch as ProductCardGallerySwitch } from './product-card-gallery'
import {
  AvailabilityDetails,
  AvailabilityStatus,
  AvailabilityStatusPresentation,
  CampaignType,
  ExternalStockAvailability,
  InternalEtaStockAvailability,
  InternalStockAvailability,
  ProductLifeCycleState,
  Scalars,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export type Maybe<T> = T | null

type AllConditional<T> = {
  [P in keyof T]?: T[P]
}

// Utility type that makes all properties optional except specified ones
/*
type SelectiveConditional<T, K extends keyof T = never> = {
  [P in keyof T as P extends K ? P : never]: T[P]
} & {
  [P in keyof T as P extends K ? never : P]?: T[P]
}*/
export type ProductTypeProps = {
  id: string
  productErpIdentifier: string
  displayName?: string | null
  englishFullDisplayName?: string | null
  primaryImageId?: Maybe<string>
  manufacturerName: string
  displaySpecifications: string
  internalProduct?: boolean | null
  nameSlug: string
  energyClass?: Maybe<string>
  energyDocumentId?: Maybe<string>
  energyLabelImageId?: Maybe<string>
  isNewProduct: boolean
  price?: Maybe<{
    campaignPercentage?: Maybe<number>
    campaignType?: Maybe<CampaignType>
    isBestSeller: boolean
    isBid: boolean
    isCampaign: boolean
    isRecommendedProduct: boolean
    price: number
    priceExcludingVat: number
    priceIncludingVat: number
    originalPrice: number
    formatted: {
      price: string
      originalPrice: string
      priceExcludingVat: string
      priceIncludingVat: string
    }
    priceVat: number
  }>
  availability?: Maybe<GenericAvailabilityType>
  promotedSpecifications: { name: string; value: string }[]
  reviewScore: number
  reviewCount: number
  manufacturerProductIdentifier?: Maybe<string>
  categoryName?: Maybe<string>
  minQuantityPerOrder?: number | null
  category?: Maybe<{ name?: Maybe<string>; englishPathSlug?: Maybe<string> }>
  showSpecificationsInProductCardTitle?: boolean | null
}

export type GenericAvailabilityType = {
  IsNotifyEligible?: Scalars['Boolean']['output']
  availabilityDetails?: Maybe<AvailabilityDetails>
  availabilityStatus: AvailabilityStatus
  availabilityStatusPresentation: AvailabilityStatusPresentation
  externalStock?: Maybe<ExternalStockAvailability>
  internal?: Scalars['Boolean']['output']
  internalEtaStock?: Maybe<InternalEtaStockAvailability>
  internalStock?: Maybe<AllConditional<InternalStockAvailability>>
  isAvailableForSale: Scalars['Boolean']['output']
  isIncludedInKit?: Scalars['Boolean']['output']
  isNotifyEligible?: Scalars['Boolean']['output']
  isPreOrder: Scalars['Boolean']['output']
  maxAvailableQuantity?: Maybe<Scalars['Int']['output']>
  productErpIdentifier?: Maybe<Scalars['String']['output']>
  productLifeCycleState: ProductLifeCycleState
  showAvailabilityQuantities: Scalars['Boolean']['output']
  showEtaDate: Scalars['Boolean']['output']
}
